import React, { useMemo, useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';

const containerStyle = {
    width: '100%',
    height: '60vh',
};

const MapliveLocationStaff = ({ locations }) => {
    const loaderOptions = useMemo(() => ({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyCVB-8zgvakDHFcP6CaQdZKZBVhgphVE5Y',
    }), []);

    const { isLoaded } = useJsApiLoader(loaderOptions);
    const navigate = useNavigate();

    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const [hoveredLocation, setHoveredLocation] = useState(null);

    const calculateCenter = useMemo(() => {
        if (locations.length === 0) return { lat: 0, lng: 0 };
        const latSum = locations.reduce((sum, loc) => sum + loc.latitude, 0);
        const lngSum = locations.reduce((sum, loc) => sum + loc.longitude, 0);
        return {
            lat: latSum / locations.length,
            lng: lngSum / locations.length,
        };
    }, [locations]);

    const handleMarkerClick = (staffId) => {
        navigate(`/user-management/registered/staffprofile/${staffId}`); // Redirect to driver profile
    };

    const handleMouseOver = (e, location) => {
        setShow(true);
        setTarget(e.domEvent.target); // Set the DOM element target
        setHoveredLocation(location); // Store the hovered location
    };


    const handleMouseOut = () => {
        setShow(false);
        setTarget(null);
        setHoveredLocation(null); // Clear the hovered location
    };

    return isLoaded ? (
        <>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={calculateCenter}
                zoom={12}
            >
                {locations.map((location, index) => (
                    <Marker
                        key={index}
                        position={{ lat: location.latitude, lng: location.longitude }}
                        icon={{
                            url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png', // Replace 'blue' with other colors if needed
                        }}
                        onClick={() => handleMarkerClick(location.staffId)}
                        onMouseOver={(e) => handleMouseOver(e, location)}
                        onMouseOut={handleMouseOut}
                    />
                ))}
            </GoogleMap>
            <Overlay target={target} show={show} placement="top">
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        {hoveredLocation?.staffName || "No Name Available"}
                    </Tooltip>
                )}
            </Overlay>

        </>
    ) : (
        <p>Loading map...</p>
    );
};

export default MapliveLocationStaff;